import {
  Textarea as GSTextArea,
  TextareaInput,
  FormControl
} from "@gluestack-ui/themed";
import { InputHelperText } from "./components/InputHelperText";
import { InputError } from "./components/InputError";
import { InputLabel } from "./components/InputLabel";
import { TextareaProps } from "./types";

export const Textarea = ({
  label,
  isLoading,
  placeholder,
  helperText,
  errorMessage,
  value,
  onChange,
  onBlur,
  isDisabled,
  isInvalid,
  isReadOnly,
  maxLength,
  isRequired,
  ...inputProps
}: TextareaProps) => {
  return (
    <FormControl
      size="md"
      $required-bgColor="blue"
      isDisabled={isDisabled || isLoading}
      isInvalid={isInvalid || !!errorMessage}
      isReadOnly={isReadOnly}
      isRequired={isRequired}
    >
      <InputLabel label={label} />
      <GSTextArea {...inputProps}>
        <TextareaInput
          placeholderTextColor="$textLight500"
          onBlur={onBlur}
          blurOnSubmit={true}
          placeholder={placeholder}
          maxLength={maxLength}
          onChangeText={onChange}
          value={value}
        />
      </GSTextArea>
      <InputHelperText text={helperText} hasError={!!errorMessage} />
      <InputError errorMessage={errorMessage} />
    </FormControl>
  );
};
